module.exports = __webpack_public_path__ + "img/border_Three_Circular_Cloud.b2a235b1.svg";